import './filter-expand.css'
import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { Button } from 'ui/button'
import { ExpandableContent } from 'ui/expandable-content'
import { useFormProps } from 'ui/form'

import Filters from 'icons/filters.svg'
import Arrow from 'icons/filter-arrow.svg'
import { cn } from 'utils'

const notFilterValues = ['limit', 'page']

export const FilterExpand = ({
  className,
  isOpen = false,
  children,
  onToggle,
  Footer,
  ...props
}) => {
  const { defaultValues } = useFormProps()
  const [showContent, setShowContent] = useState(isOpen)

  const hasFilters = useMemo(() => {
    return Object.entries(defaultValues).some(([key, value]) => {
      if (notFilterValues.includes(key)) {
        return false
      }
      return Boolean(Array.isArray(value) ? value?.length : value)
    })
  }, [defaultValues])

  const toggleOpenClose = useCallback(() => {
    setShowContent(!showContent)
  }, [showContent])

  return (
    <div
      className={cn('filter-expand', showContent && 'open', hasFilters && 'has-filters', className)}
      {...props}
    >
      <ExpandableContent isOpen={showContent} className="filters-wrapper">
        {children}
      </ExpandableContent>

      <div className="filters-footer">
        <Button
          className={cn('toggle-button', showContent && 'open')}
          theme="flat"
          onClick={toggleOpenClose}
        >
          <Filters />
          <span className="less">Hide&nbsp;</span>
          <span className="filters">Filters</span>
          <Arrow />
          <span className="indicator" />
        </Button>
        <Footer />
      </div>
    </div>
  )
}

FilterExpand.propTypes = {
  Footer: PropTypes.elementType,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
}
